import React from 'react'

import {
  getCookieStatus,
  updateCookieStatus,
  CookieSettingsState,
  addAcceptCookiesListener
} from './cookiebar.utils.mod'

export class CookieBar extends React.Component<{}, CookieSettingsState> {
  constructor(props: {}) {
    super(props)

    this.state = {
      cookieStatus: getCookieStatus(),
      unsubListener: () => {}
    }
  }

  componentDidMount() {
    const unsubListener = addAcceptCookiesListener(() => this.setState(updateCookieStatus))
    this.setState(s => ({ ...s, unsubListener }))
  }

  componentWillUnmount() {
    this.state.unsubListener()
  }

  render() {
    if (this.state.cookieStatus !== 'undecided') return <></>

    return (
      <div className="cookiebar">
        {/* <div className="cookiebar__inner gutter--default cf">
          <p className="cookiebar__text text--styled">
            Welkom op de website van het Diakonessenhuis. Voor onze filmpjes gebruiken we YouTube. Om die af te spelen,
            plaatst YouTube cookies. Wilt u liever geen YouTube cookie? Dan kunt u dit hier weigeren. U kunt dan geen
            filmpjes bekijken. We gebruiken zelf functionele en analytische cookies om onze website goed te laten
            werken. <Link to="/aansprakelijkheid/cookies">Meer weten over cookies</Link>?
          </p>

          <div className="cookiebar__actions">
            <button
              className="block__button button--primary"
              onClick={_ => {
                acceptCookies()
                this.setState(s => ({ ...s, cookieStatus: 'accepted' }))
              }}
            >
              Akkoord
            </button>

            <button
              className="block__button button--link"
              onClick={_ => {
                rejectCookies(this.state.cookieStatus)
                this.setState(s => ({ ...s, cookieStatus: 'rejected' }))
              }}
            >
              Nee, geen YouTube cookie
            </button>
          </div>
        </div> */}
      </div>
    )
  }
}

export interface CookieSensitiveContentWrapperProps {
  children: React.ReactNode
  placeholder: React.ReactNode
  options: { style?: CookieSensitiveContentWrapperStyle; key?: string }
}

export type CookieSensitiveContentWrapperStyle = Partial<{
  cookies_classname: string
  cookies_inner_classname: string
  cookies_text_classname: string
  cookies_clickable_classname: string
}>

export class CookieSensitiveContentWrapper extends React.Component<
  CookieSensitiveContentWrapperProps,
  CookieSettingsState
> {
  constructor(props: CookieSensitiveContentWrapperProps) {
    super(props)

    this.state = {
      cookieStatus: getCookieStatus(),
      unsubListener: () => {}
    }
  }

  componentDidMount() {
    const unsubListener = addAcceptCookiesListener(() => this.setState(updateCookieStatus))
    this.setState(s => ({ ...s, unsubListener }))
  }

  componentWillUnmount() {
    this.state.unsubListener()
  }

  render() {
    if (this.state.cookieStatus == 'complete' || this.state.cookieStatus == 'limited') return this.props.children

    return (
      <div
        className={
          this.props.options.style.cookies_classname
            ? this.props.options.style.cookies_classname
            : 'text-center bg-light'
        }
      >
        <div
          className={
            this.props.options.style.cookies_inner_classname ? this.props.options.style.cookies_inner_classname : 'p-5'
          }
        >
          <p
            className={
              this.props.options.style.cookies_text_classname ? this.props.options.style.cookies_text_classname : ''
            }
          >
            {this.props.placeholder}
          </p>
          {/* <button
            className={
              this.props.options.style.cookies_clickable_classname
                ? this.props.options.style.cookies_clickable_classname
                : 'btn btn-dark'
            }
            onClick={_ => acceptCookies()}
          >
            {t('cookiebar.accept')}
          </button> */}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./Client/components/cms/blocks/cookiebar.mod.tsx